var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:( _obj = {}, _obj[("form-" + _vm.type)] = true, _obj[("input-" + _vm.size)] = true, _obj )},[_c('input',_vm._g(_vm._b({},'input',_vm.$props,false),_vm.$listeners)),_c('i',{staticClass:"form-icon"}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }